var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.59 3.577a.833.833 0 0 0-1.18 1.179l4.412 4.41H4.167a.833.833 0 0 0 0 1.667h9.655L9.41 15.244a.833.833 0 1 0 1.178 1.179l5.834-5.834a.833.833 0 0 0 0-1.178l-5.834-5.834Z"
  })));
};
export default SvgArrowRight;